Q         = require('q')
axios     = require('axios')
csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content')

module.exports =
  namespaced: true

  state:
    csrfToken: csrfToken

  actions:

    call: (context, axiosConfig = {}) ->
      d = Q.defer()

      # baseUrl
      host = context.rootState.settings.host.full
      host = "#{host.replace(/\/$/, '')}/"
      axiosConfig.baseURL = host

      # headers
      axiosConfig.headers or= {}
      axiosConfig.headers['X-CSRF-Token'] = context.state.csrfToken
      axiosConfig.headers['Accept'] = 'application/json'
      axiosConfig

      # prevent redirect following
      axiosConfig.maxRedirects = 0

      # call
      axios(axiosConfig)
      .then (responseData) => d.resolve(responseData)
      .catch (error) => d.reject(error)

      # return
      d.promise



// WEBPACK FOOTER //
// ./assets/js/shared/store/net/index.coffee